/** @jsxImportSource @emotion/react */
import React from 'react'

interface ShareIconProps {
  size?: number
  color?: string
  className?: string
}

const ShareIcon: React.FC<ShareIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    className={className}
  >
    <path
      d='M12.6667 11.3333C12.0933 11.3333 11.58 11.5533 11.18 11.9L5.94 8.78C5.97333 8.62667 6 8.47333 6 8.31333C6 8.15333 5.97333 8 5.94 7.84667L11.12 4.76C11.5333 5.22667 12.0667 5.5 12.6667 5.5C13.9533 5.5 15 4.45333 15 3.16667C15 1.88 13.9533 0.833336 12.6667 0.833336C11.38 0.833336 10.3333 1.88 10.3333 3.16667C10.3333 3.32667 10.36 3.48 10.3933 3.63333L5.21333 6.71333C4.8 6.24667 4.26667 5.97333 3.66667 5.97333C2.38 5.97333 1.33333 7.02 1.33333 8.30667C1.33333 9.59333 2.38 10.64 3.66667 10.64C4.26667 10.64 4.8 10.3667 5.21333 9.9L10.44 13.0133C10.4067 13.1533 10.3867 13.3 10.3867 13.4467C10.3867 14.7 11.4133 15.7267 12.6667 15.7267C13.92 15.7267 14.9467 14.7 14.9467 13.4467C14.9467 12.1933 13.92 11.1667 12.6667 11.1667V11.3333Z'
      fill={color}
    />
  </svg>
)

export default ShareIcon
